
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93Y8MrXgRHEPl7YxdGJom9FG2TbKBq05QpJvQYoT2wQq4Meta } from "/codebuild/output/src3520219688/src/ark/pages/[...slug].vue?macro=true";
import { default as guiasyG3wjciNRxM3p6M2gTBysVvypZAn2Q8qiP9YtRoqECUMeta } from "/codebuild/output/src3520219688/src/ark/pages/blog/guias.vue?macro=true";
import { default as indexvfTeDvp_45mwVZTpJcovPteAKQn8aTkpoPZgRqIphce5sMeta } from "/codebuild/output/src3520219688/src/ark/pages/blog/index.vue?macro=true";
import { default as temassMvtRAa8dM0MydP6n_Aw0Ci0GOIUzmD_3dCj2XN2u7EMeta } from "/codebuild/output/src3520219688/src/ark/pages/blog/temas.vue?macro=true";
import { default as pesquisayt0K3gsZ6M2sGrql_Mo1NA4WxEl5_45OOOAaucOhniN68Meta } from "/codebuild/output/src3520219688/src/ark/pages/blog/pesquisa.vue?macro=true";
import { default as morada9WDSy21gkQNlUtgmXoCBqpt8EtUbPw2EBDGFhXP7zyMMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue?macro=true";
import { default as habitanteso2nFVN1osCrvMTL3fVjkYUuLW3QrhwpHInPWJOCw_45PsMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue?macro=true";
import { default as escalao_45gaso_chO8gDvYHUoSc7T2PDLXllByyewOvaIYOjC7xF3nYMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue?macro=true";
import { default as tempo_45em_45casabJ9sxEgky7g0QLmcfvhkWWqsDTeOK85u6t8SkT7USxgMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue?macro=true";
import { default as tipo_45de_45produtob_45Bu_45hT4_45jTyWTIX_nJKGnDoaDoZGu_45BulzWT79i6q8Meta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue?macro=true";
import { default as comercializadoraS4gSJc8NxLgwKjsnv6XhV2v_453zi9Au8mS1GD6QHqZlcMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue?macro=true";
import { default as dados_45de_45contactoSf2f9BbNQessbOn0CYqufXh05vg8dUdfcHBcz04RMZcMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue?macro=true";
import { default as potencia_45contratadaLLmGyaeClTAtqtQOmUul64txB9q8OsOHNj0lGGQaCScMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue?macro=true";
import { default as simularvnJAWn1GlvM0fH3jXxiqFpxEWazUn_e334dGpJvNiKcMeta } from "/codebuild/output/src3520219688/src/ark/pages/energia/simular.vue?macro=true";
import { default as internetVOPJ3cs5WrRzVhgMIAfeDEXsIT_GFsu_m1C8wPRDkLoMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue?macro=true";
import { default as telemovel1XxoP3PIHn_BBBGikzn_zJXJDVOYfD75ZW0EVvtqJOsMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue?macro=true";
import { default as fidelizacaoKS8sn6K6pJDB3ipiHnokF0NQZmjp7i00SE4mdvnZPKYMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue?macro=true";
import { default as operadora_45atualDKgCsVSfk_Vj_NwUyWso5ZYLn2fIjUMU__72sJGB3ngMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue?macro=true";
import { default as dados_45de_45contacto5c0B2T_45XyU2yqMASqqpfaUhrw4_45JMPlfYZz9qVKTTWcMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue?macro=true";
import { default as simularm7Djd4UHroVa7v3szDzm05WKL8o5rU0Vt2_45n1RqdNjoMeta } from "/codebuild/output/src3520219688/src/ark/pages/tv-net-voz/simular.vue?macro=true";
import { default as _91_46_46_46slug_93WaH56xdwLBR8XMJYqjNbDzMZoLMlbXRYdzt0uJKUvsIMeta } from "/codebuild/output/src3520219688/src/ark/pages/blog/autor/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_931za4D_45ZAS2D6GkM5mwrVYfpyb9FfMt2t5afa4yS6vpkMeta } from "/codebuild/output/src3520219688/src/ark/pages/blog/rubricas/[...slug].vue?macro=true";
import { default as resumoqVSPAIf9TVLw1nRR_45PumL2vh6OZIiYafWcM6_cKZOkkMeta } from "/codebuild/output/src3520219688/src/ark/pages/depositos-a-prazo/resumo.vue?macro=true";
import { default as finalidadeGzCoXgVD_45IoBvgEIgf3ei00PSyd1e1wbDebGYHVfmQ0Meta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue?macro=true";
import { default as tipo_45de_45taxaAB8NzJrL0rhlVxmd_pto1vfAAGdcDeX4teJURCqitokMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue?macro=true";
import { default as dados_45de_45contactoslEqxb18HlGHhkVF6397N1ujV6OBeqtA4O09Jqye1x8Meta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue?macro=true";
import { default as estado_45do_45processo9DuyhTzFkJ_8Y5U8dfWp3TuYEF9nSAMFGk_z1mKwX2sMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue?macro=true";
import { default as situacao_45financeiraocitn1OlSrAGDX_45ztu5EReKQHQ_W0LY_45AMwpO5VP1LgMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue?macro=true";
import { default as montante_45do_45emprestimo5bpdLguNjYWJCdW5xjPv_45r9uWVFcXYOCe__I_siYMUgMeta } from "/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue?macro=true";
import { default as simularjC84S2laVUf2_mpEHiEQoxclnvyqYb6wZ27IZtTx0UAMeta } from "/codebuild/output/src3520219688/src/ark/pages/credito-habitacao/simular.vue?macro=true";
import { default as _91_46_46_46slug_93EpWmrDV1YvygLORYF7NDVNFwrytkNu13Fi2o0K4B4GMMeta } from "/codebuild/output/src3520219688/src/ark/pages/simuladores/embed/[...slug].vue?macro=true";
import { default as resultadosU3oQUX69vWGi00oq65N_TGpYXHmqXJeJINZ05s8CJyYMeta } from "/codebuild/output/src3520219688/src/ark/pages/credito-habitacao/resultados.vue?macro=true";
import { default as indexkKeGlbGpo45XcwnKSWf57SAyRE7IS1JrlzlvbHzQWHsMeta } from "/codebuild/output/src3520219688/src/ark/pages/parcerias-imobiliarias/index.vue?macro=true";
import { default as _91_46_46_46slug_93As_A7_45FSZQ8QkFIsLL7LQWUl0MhdcruAZKJPO68xrtwMeta } from "/codebuild/output/src3520219688/src/ark/pages/tv-net-voz/campanhas/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93__45PeGMquLLhrTL1SkfxG8sZ25c0sDc_457lTBYG5hkr_AMeta } from "/codebuild/output/src3520219688/src/ark/pages/parcerias-imobiliarias/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/[...slug].vue")
  },
  {
    name: "blog-guias",
    path: "/blog/guias",
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/blog/guias.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/blog/index.vue")
  },
  {
    name: "blog-temas",
    path: "/blog/temas",
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/blog/temas.vue")
  },
  {
    name: "blog-pesquisa",
    path: "/blog/pesquisa",
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/blog/pesquisa.vue")
  },
  {
    name: "energia-simular",
    path: "/energia/simular",
    meta: { ...(simularvnJAWn1GlvM0fH3jXxiqFpxEWazUn_e334dGpJvNiKcMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/energia/simular.vue"),
    children: [
  {
    name: "energia-simular-morada",
    path: "morada",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue")
  },
  {
    name: "energia-simular-habitantes",
    path: "habitantes",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue")
  },
  {
    name: "energia-simular-escalao-gas",
    path: "escalao-gas",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue")
  },
  {
    name: "energia-simular-tempo-em-casa",
    path: "tempo-em-casa",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue")
  },
  {
    name: "energia-simular-tipo-de-produto",
    path: "tipo-de-produto",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue")
  },
  {
    name: "energia-simular-comercializadora",
    path: "comercializadora",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue")
  },
  {
    name: "energia-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue")
  },
  {
    name: "energia-simular-potencia-contratada",
    path: "potencia-contratada",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue")
  }
]
  },
  {
    name: "tv-net-voz-simular",
    path: "/tv-net-voz/simular",
    meta: { ...(simularm7Djd4UHroVa7v3szDzm05WKL8o5rU0Vt2_45n1RqdNjoMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/tv-net-voz/simular.vue"),
    children: [
  {
    name: "tv-net-voz-simular-internet",
    path: "internet",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue")
  },
  {
    name: "tv-net-voz-simular-telemovel",
    path: "telemovel",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue")
  },
  {
    name: "tv-net-voz-simular-fidelizacao",
    path: "fidelizacao",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue")
  },
  {
    name: "tv-net-voz-simular-operadora-atual",
    path: "operadora-atual",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue")
  },
  {
    name: "tv-net-voz-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue")
  }
]
  },
  {
    name: "blog-autor-slug",
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/blog/autor/[...slug].vue")
  },
  {
    name: "blog-rubricas-slug",
    path: "/blog/rubricas/:slug(.*)*",
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/blog/rubricas/[...slug].vue")
  },
  {
    name: "depositos-a-prazo-resumo",
    path: "/depositos-a-prazo/resumo",
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/depositos-a-prazo/resumo.vue")
  },
  {
    name: "credito-habitacao-simular",
    path: "/credito-habitacao/simular",
    meta: { ...(simularjC84S2laVUf2_mpEHiEQoxclnvyqYb6wZ27IZtTx0UAMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/credito-habitacao/simular.vue"),
    children: [
  {
    name: "credito-habitacao-simular-finalidade",
    path: "finalidade",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue")
  },
  {
    name: "credito-habitacao-simular-tipo-de-taxa",
    path: "tipo-de-taxa",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue")
  },
  {
    name: "credito-habitacao-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue")
  },
  {
    name: "credito-habitacao-simular-estado-do-processo",
    path: "estado-do-processo",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue")
  },
  {
    name: "credito-habitacao-simular-situacao-financeira",
    path: "situacao-financeira",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue")
  },
  {
    name: "credito-habitacao-simular-montante-do-emprestimo",
    path: "montante-do-emprestimo",
    component: () => import("/codebuild/output/src3520219688/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue")
  }
]
  },
  {
    name: "simuladores-embed-slug",
    path: "/simuladores/embed/:slug(.*)*",
    meta: _91_46_46_46slug_93EpWmrDV1YvygLORYF7NDVNFwrytkNu13Fi2o0K4B4GMMeta || {},
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/simuladores/embed/[...slug].vue")
  },
  {
    name: "credito-habitacao-resultados",
    path: "/credito-habitacao/resultados",
    meta: resultadosU3oQUX69vWGi00oq65N_TGpYXHmqXJeJINZ05s8CJyYMeta || {},
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/credito-habitacao/resultados.vue")
  },
  {
    name: "parcerias-imobiliarias",
    path: "/parcerias-imobiliarias",
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/parcerias-imobiliarias/index.vue")
  },
  {
    name: "tv-net-voz-campanhas-slug",
    path: "/tv-net-voz/campanhas/:slug(.*)*",
    meta: _91_46_46_46slug_93As_A7_45FSZQ8QkFIsLL7LQWUl0MhdcruAZKJPO68xrtwMeta || {},
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/tv-net-voz/campanhas/[...slug].vue")
  },
  {
    name: "parcerias-imobiliarias-slug",
    path: "/parcerias-imobiliarias/:slug(.*)*",
    meta: _91_46_46_46slug_93__45PeGMquLLhrTL1SkfxG8sZ25c0sDc_457lTBYG5hkr_AMeta || {},
    component: () => import("/codebuild/output/src3520219688/src/ark/pages/parcerias-imobiliarias/[...slug].vue")
  }
]